import firebase from "firebase/app";
import "firebase/messaging";
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();

const firebaseConfig = {
  apiKey: publicRuntimeConfig.API_KEY,
  authDomain: publicRuntimeConfig.AUTH_DOMAIN,
  databaseURL: publicRuntimeConfig.DATABASE_URL,
  projectId: publicRuntimeConfig.PROJECT_ID,
  storageBucket: publicRuntimeConfig.STORAGE_BUCKET,
  messagingSenderId: publicRuntimeConfig.MESSAGING_SENDER_ID,
  appId: publicRuntimeConfig.APP_ID,
  measurementId: publicRuntimeConfig.MEASUREMENT_ID
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const getToken = () => {
  const messaging = firebase.messaging();
  return messaging
    .getToken({
      vapidKey: publicRuntimeConfig.VAPIDKEY
    })
    .then(currentToken => {
      if (currentToken) {
        return currentToken;
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch(err => {
      console.log("An error occurred while retrieving token. ", err);
    });
};

export const onMessageListener = () =>
  new Promise(resolve => {
    const messaging = firebase.messaging();
    messaging.onMessage(payload => {
      resolve(payload);
    });
  });

export const onBackgroundMessageListener = () =>
  new Promise(async resolve => {
    const registration = await navigator.serviceWorker
      .register("/firebase-messaging-sw.js", {
        scope: "/firebase-cloud-messaging-push-scope",
        updateViaCache: "none"
      })
      .then(registration => {
        return registration;
      });
    registration.getNotifications({}).then(function(notifications) {
      resolve(notifications);
    });
  });



// WEBPACK FOOTER //
// client/firebase.js